/**
 * Decider for "ordered" policy (personalization)
 * @module
 */

var deciderFns = require('core/decision/decider_fns');
var DecisionError = require('core/decision/error').DecisionError;

/**
 * @constant
 * @type {string}
 */
var ORDERED = 'ordered';

var pluginDeciderOrdered:Decider = {
  /**
   * Select the first valid experiment given audienceIds.
   * @param {Layer} layer
   * @param {string[]} audienceIds
   * @param {string} bucketingId Ignored
   * @returns {Experiment}
   * @throws {DecisionError} if not eligible for any experiments
   */
  selectExperiment: function(layer:Layer, audienceIds:string[], bucketingId:string): Experiment {
    // Always choose the first candidate experiment
    for (var i = 0; i < layer.experiments.length; i++) {
      if (deciderFns.isValidExperiment(audienceIds, layer.experiments[i])) {
        return layer.experiments[i];
      }
    }

    throw new DecisionError('Not eligible for any experiments');
  },
};

module.exports = function(PluginManager) {
  PluginManager.registerDecider(ORDERED, pluginDeciderOrdered);
};

if (__TEST__) {
  module.exports.plugin = pluginDeciderOrdered;
}
